<template>
  <div style="padding: 20px 0">
    <el-form
      :inline="true"
      :model="statementForm"
      label-position="left"
      class="demo-form-inline"
    >
      <el-form-item label="仓库：" v-if="itemShow.placeholder_key1">
        <el-select v-model="statementForm.placeholder_key1" placeholder="仓库">
          <el-option label="value1" :value="0"></el-option>
          <el-option label="value2" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：" v-if="itemShow.placeholder_key2">
        <el-date-picker
          v-model="statementForm.placeholder_key2"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          @change="timeChange"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="入库名称" v-if="itemShow.placeholder_key5">
        <el-select
          v-model="statementForm.placeholder_key5"
          placeholder="入库名称"
        >
          <el-option label="value1" :value="0"></el-option>
          <el-option label="value2" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库名称" v-if="itemShow.placeholder_key6">
        <el-select
          v-model="statementForm.placeholder_key6"
          placeholder="出库名称"
        >
          <el-option label="value1" :value="0"></el-option>
          <el-option label="value2" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="库区类型：" v-if="itemShow.placeholder_key3">
        <el-select v-model="statementForm.placeholder_key3" placeholder="全部">
          <el-option label="value1" :value="0"></el-option>
          <el-option label="value2" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型：" v-if="itemShow.placeholder_key4">
        <el-select v-model="statementForm.placeholder_key4" placeholder="全部">
          <el-option label="value1" :value="0"></el-option>
          <el-option label="value2" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import moment from "moment";
import { showitemMap } from "./showitem.js";
export default {
  name: "StatementForm",
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statementForm: {},
      itemShow: {},
      itemShowMap: showitemMap,
    };
  },
  created() {
    let itemShowMap = this.itemShowMap;
    this.itemShow = itemShowMap[this.source];
  },
  watch: {},
  methods: {
    timeChange() {},
    onSubmit() {},
  },
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
